import { Suspense } from 'react';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import { StartHere as StartHereView } from '@modules/Info/views/StartHere';

export const StartHere = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%" />}>
        <StartHereView />
      </Suspense>
    </ErrorBoundary>
  );
};
